// Thai. Keys omitted here fall back to English (see src/i18n/index.js).
// "RPilot" is a brand name and stays untranslated.
export default {
  'common.cancel': 'ยกเลิก',
  'common.submit': 'ส่ง',
  'common.save': 'บันทึก',
  'common.create': 'สร้าง',
  'common.delete': 'ลบ',
  'common.close': 'ปิด',
  'common.retry': 'ลองใหม่',
  'common.confirm': 'ยืนยัน',
  'common.areYouSure': 'คุณแน่ใจหรือไม่?',

  'chat.startConversation': 'เริ่มการสนทนา',
  'chat.inputPlaceholder': 'พิมพ์ข้อความ...',
  'chat.inputPlaceholderNoCredits': 'เครดิต RPilot หมดแล้ว',
  'chat.creditsUsedUpFooter': 'เครดิต RPilot ของทีมคุณหมดแล้ว เริ่มแชทใหม่เมื่อมีการต่ออายุเครดิต',
  'chat.newChat': 'แชทใหม่',
  'chat.useSkill': 'ใช้สกิล',
  'chat.skills': 'สกิล',
  'chat.loadingSkills': 'กำลังโหลดสกิล…',
  'chat.noSkill': 'ไม่ใช้สกิล',
  'chat.noSkillsAvailable': 'ไม่มีสกิลที่ใช้ได้',
  'chat.appliesNextMessage': 'มีผลตั้งแต่ข้อความถัดไปของคุณ',
  'chat.attachImage': 'แนบรูปภาพ',
  'chat.attachFile': 'แนบไฟล์',
  'chat.fileTooLarge': 'ไฟล์ใหญ่เกินไป (สูงสุด {size})',
  'chat.uploadFailed': 'อัปโหลดไม่สำเร็จ',
  'chat.download': 'ดาวน์โหลด',
  'chat.recordVoice': 'อัดเสียง',
  'chat.stopRecording': 'หยุดอัดเสียง',
  'chat.stop': 'หยุด',
  'chat.send': 'ส่ง',
  'chat.thinking': 'กำลังคิด…',
  'chat.thoughtProcess': 'กระบวนการคิด',
  'chat.waitingForHost': 'กำลังรอแดชบอร์ด…',
  'chat.thinkingComplete': 'คิดเสร็จแล้ว',
  'chat.toolUsedOne': 'ใช้เครื่องมือ 1 รายการ',
  'chat.toolsUsedCount': 'ใช้เครื่องมือ {count} รายการ',
  'chat.usedNames': 'ใช้ {names}',
  'chat.usedToolsCount': 'ใช้เครื่องมือ {count} รายการ',
  'chat.running': 'กำลังทำงาน',
  'chat.details': 'รายละเอียด',
  'chat.arguments': 'อาร์กิวเมนต์',
  'chat.result': 'ผลลัพธ์',
  'chat.error': 'ข้อผิดพลาด',
  'chat.done': 'เสร็จสิ้น',
  'chat.openInNewTab': 'เปิดในแท็บใหม่',
  'chat.openInDocsSite': 'เปิดในเว็บไซต์เอกสาร',
  'chat.noPageContent': 'ไม่มีเนื้อหาสำหรับหน้านี้',
  'chat.goodResponse': 'คำตอบดี',
  'chat.badResponse': 'คำตอบไม่ดี',
  'chat.whatWentWrong': 'เกิดอะไรผิดพลาด?',
  'chat.optionalFeedback': 'ความคิดเห็นเพิ่มเติม (ไม่บังคับ)...',

  'approval.required': 'ต้องได้รับการอนุมัติ',
  'approval.requiredCount': 'ต้องได้รับการอนุมัติ — {count} รายการ',
  'approval.approve': 'อนุมัติ',
  'approval.deny': 'ปฏิเสธ',
  'approval.approveAll': 'อนุมัติทั้งหมด',
  'approval.approveSelected': 'อนุมัติที่เลือก ({count})',
  'approval.denyAll': 'ปฏิเสธทั้งหมด',
  'approval.andMore': '…และอีก {count} รายการ',
  'approval.approvedChip': 'อนุมัติแล้ว',
  'approval.deniedChip': 'ปฏิเสธแล้ว',
  'approval.timedOutChip': 'หมดเวลา',
  'approval.countApproved': 'อนุมัติแล้ว {count} รายการ',
  'approval.countDenied': 'ปฏิเสธแล้ว {count} รายการ',
  'approval.countTimedOut': 'หมดเวลา {count} รายการ',
  'approval.timedOut': 'หมดเวลา',
  'approval.settled': 'ดำเนินการแล้ว',

  'header.expand': 'ขยาย',
  'header.collapse': 'ย่อ',
  'header.menu': 'เมนู',
  'drawer.sessions': 'เซสชัน',
  'drawer.skills': 'สกิล',
  'drawer.settings': 'การตั้งค่า',
  'drawer.noSessions': 'ยังไม่มีเซสชัน',
  'drawer.chatFallbackTitle': 'แชท {id}',
  'drawer.newSkill': 'สกิลใหม่',
  'drawer.searchSkills': 'ค้นหาสกิล...',
  'drawer.noSkillsMatch': 'ไม่พบสกิลที่ตรงกับการค้นหา',
  'drawer.noSkillsYet': 'ยังไม่มีสกิล สร้างสกิลแรกเพื่อเริ่มต้น',
  'drawer.mySkills': 'สกิลของฉัน',
  'drawer.builtIn': 'ในตัว',
  'drawer.shared': 'แชร์แล้ว',
  'drawer.showToolCalls': 'แสดงการเรียกใช้เครื่องมือ',
  'drawer.autoAcceptEdits': 'ยอมรับการแก้ไขอัตโนมัติ',
  'drawer.darkMode': 'โหมดมืด',
  'drawer.version': 'เวอร์ชัน',
  'drawer.versionCopied': 'คัดลอกแล้ว',

  'gate.meetTitle': 'พบกับ RPilot',
  'gate.meetBody': 'RPilot คือผู้ช่วย AI ของคุณสำหรับ RDrive ถามเกี่ยวกับแบบ ปัญหา แผนงาน และข้อมูลโครงการด้วยภาษาธรรมดา แล้วรับคำตอบที่ชัดเจนพร้อมลิงก์ตรงเข้าสู่แอป',
  'gate.meetCta': 'อยากใช้ RPilot สำหรับทีมของคุณ? ติดต่อทีมขายของเรา',
  'gate.outOfCreditsTitle': 'เครดิต RPilot ของคุณหมดแล้ว',
  'gate.outOfCreditsBody': 'เครดิต RPilot ของทีมคุณหมดแล้ว ติดต่อเราเพื่อต่ออายุแล้วทำงานต่อจากที่ค้างไว้',
  'credits.title': 'การใช้เครดิต',
  'credits.loadFailed': 'ไม่สามารถโหลดการใช้เครดิตได้',
  'credits.active': 'ใช้งานอยู่',
  'credits.fallback': 'สำรอง',
  'credits.exhausted': 'หมดแล้ว',
  'credits.noPools': 'ไม่มีพูลเครดิต',
  'credits.daily': 'รายวัน',
  'credits.weekly': 'รายสัปดาห์',
  'credits.monthly': 'รายเดือน',
  'credits.dayShort': 'ว.',
  'credits.weekShort': 'ส.',
  'credits.monthShort': 'ด.',
  'credits.usedNoLimit': '{label} — ใช้ไป {spent} (ไม่จำกัด)',
  'credits.balanceLine': 'ยอดคงเหลือ: {balance} เครดิต · รีเซ็ตเวลาเที่ยงคืน {zone}',
  'credits.account': 'บัญชี',
  'credits.scopeProject': 'โครงการ',
  'credits.scopeTeam': 'ทีม',
  'credits.scopeMixed': 'ผสม',
  'credits.scopePool': 'พูล',
  'credits.messageNotSent': 'เครดิต RPilot ของทีมคุณหมดแล้ว จึงไม่สามารถส่งข้อความนี้ได้ บทสนทนาของคุณถูกบันทึกไว้แล้ว',
  'credits.contactUs': 'ติดต่อเรา',

  'sales.contactSales': 'ติดต่อฝ่ายขาย',
  'sales.requestReceived': 'ได้รับคำขอแล้ว ✓',
  'sales.submitAgain': 'ส่งอีกครั้ง',
  'sales.name': 'ชื่อ',
  'sales.workEmail': 'อีเมลที่ทำงาน',
  'sales.companyTeam': 'บริษัท / ทีม (ไม่บังคับ)',
  'sales.message': 'ข้อความ (ไม่บังคับ)',
  'sales.nameRequired': 'กรุณากรอกชื่อ',
  'sales.emailRequired': 'กรุณากรอกอีเมลที่ทำงาน',
  'sales.emailInvalid': 'กรุณากรอกอีเมลที่ถูกต้อง',
  'sales.thanks': 'ขอบคุณ — ทีมของเราจะติดต่อกลับ',
  'sales.alreadyReceived': 'เราได้รับคำขอของคุณแล้ว — เราจะติดต่อกลับ',
  'sales.genericError': 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
  'sales.speakWithSales': 'พูดคุยกับฝ่ายขาย',
  'sales.salesChatPrefill': 'สวัสดี ฉันต้องการพูดคุยกับฝ่ายขายเกี่ยวกับ RPilot สำหรับทีมของฉัน',


  'skill.newSkill': 'สกิลใหม่',
  'skill.editTitle': 'แก้ไข — {name}',
  'skill.viewTitle': '{name}',
  'skill.readOnlyHint': 'นี่คือสกิลในตัวที่ดูแลโดย RDrive และไม่สามารถแก้ไขได้ หากต้องการปรับแต่งสำหรับโครงการนี้ ให้สร้างสกิลที่แชร์โดยใช้ชื่อเดียวกัน — สกิลนั้นจะมีความสำคัญเหนือกว่าที่นี่',
  'skill.name': 'ชื่อ',
  'skill.nameHint': 'ตัวระบุแบบ kebab-case',
  'skill.nameRule': 'ต้องเป็น kebab-case (เช่น review-rfi)',
  'skill.shared': 'แชร์',
  'skill.description': 'คำอธิบาย',
  'skill.descriptionPlaceholder': 'สกิลนี้ทำอะไรและใช้เมื่อใด',
  'skill.required': 'จำเป็น',
  'skill.tags': 'แท็ก',
  'skill.tagsPlaceholder': 'พิมพ์แล้วกด Enter',
  'skill.allowedTools': 'เครื่องมือที่อนุญาต',
  'skill.allToolsAllowed': 'อนุญาตทุกเครื่องมือ',
  'skill.instructions': 'คำแนะนำ (Markdown)',
  'skill.contentRequired': 'กรุณากรอกเนื้อหา',
  'skill.deleteTitle': 'ลบสกิล',
  'skill.deleteMessage': 'ลบสกิล "{name}"? การกระทำนี้ไม่สามารถย้อนกลับได้',

  'picker.selectLocation': 'เลือกตำแหน่ง',
  'picker.searchDrawings': 'ค้นหาแบบ...',
  'picker.planViewerFailed': 'ไม่สามารถโหลดตัวดูแบบได้',
  'picker.selectDrawing': 'เลือกแบบเพื่อดู',
  'picker.tapToPlace': 'แตะหมุดตำแหน่งเพื่อวางปัญหา',
  'picker.pinPlaced': 'วางหมุดแล้ว',

  'md.bold': 'ตัวหนา',
  'md.italic': 'ตัวเอียง',
  'md.heading': 'หัวข้อ',
  'md.inlineCode': 'โค้ดในบรรทัด',
  'md.codeBlock': 'บล็อกโค้ด',
  'md.link': 'ลิงก์',
  'md.bulletList': 'รายการสัญลักษณ์',
  'md.numberedList': 'รายการลำดับเลข',
  'md.blockquote': 'คำพูดอ้างอิง',
  'md.nothingToPreview': 'ไม่มีอะไรให้แสดงตัวอย่าง',
}
